/** dto for grant and revoke user role */
export class StaffRoleDto {
    constructor(private readonly id: number, private readonly rolname: string) {}
}
